"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { useSession } from "@/lib/auth-client";
import { Loader2 } from "lucide-react";

export function AuthButton() {
  const { data: session, isPending } = useSession();

  if (isPending) {
    return (
      <Button
        variant="outline"
        size="sm"
        className="border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white"
        disabled
      >
        <Loader2 className="h-4 w-4 animate-spin" />
      </Button>
    );
  }

  if (session?.user) {
    return (
      <Button
        asChild
        variant="outline"
        size="sm"
        className="border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white"
      >
        <Link href="/dashboard" prefetch={false}>
          Dashboard
        </Link>
      </Button>
    );
  }

  return (
    <Button
      asChild
      variant="outline"
      size="sm"
      className="border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white"
    >
      <Link href="/login">Iniciar Sesión</Link>
    </Button>
  );
}

export function AuthButtonFallback() {
  return (
    <Button
      variant="outline"
      size="sm"
      className="border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white"
      disabled
    >
      <Loader2 className="h-4 w-4 animate-spin" />
    </Button>
  );
}
